import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./subsection.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import { ReactNode } from "react";

type SubsectionProps = {
  title: ReactNode;
  subtitle?: string;
  children: any;
  withSidePadding?: boolean;
  greyBg?: boolean;
  subtitleH4?: boolean;
  titleH2?: boolean;
  subSectionPaddingReduced?: boolean;
  isDesktop?: boolean;
  isCustomPadding?: boolean;
  isWhitelabel?: boolean;
  className?: any;
  /** Optional content pinned to the right edge of the header row, e.g. a "Powered by" badge. */
  headerAside?: ReactNode;
  noPaddingTop?: boolean;
  hideBottomBorder?: boolean;
  noMarginBottom?: boolean;
  largeMarginBottom?: boolean;
};

const Subsection = ({
  title = "",
  subtitle = "",
  children,
  withSidePadding = true,
  greyBg = false,
  subtitleH4 = false,
  titleH2 = false,
  subSectionPaddingReduced = false,
  isDesktop = false,
  isCustomPadding = false,
  isWhitelabel = false,
  className = "",
  headerAside = null,
  noPaddingTop = false,
  hideBottomBorder = false,
  noMarginBottom = false,
  largeMarginBottom = false,
}: SubsectionProps) => {
  const { isWhitelabel: isWhitelabelApp } = useWhitelabel();

  const heading = (
    <>
      {titleH2 ? (
        <h2 className={formatClassNames(isWhitelabelApp && "wl-title-font", styles.title)}>
          {title}
        </h2>
      ) : (
        <h4 className={styles.title}>{title}</h4>
      )}
      {subtitleH4 ? (
        <h4 className={styles.subtitle}>{subtitle}</h4>
      ) : (
        <h5 className={styles.subtitle}>{subtitle}</h5>
      )}
    </>
  );

  return (
    <>
      <div
        data-testid={typeof title === "string" ? title : "subsection"}
        className={formatClassNames(
          !isDesktop && subSectionPaddingReduced ? styles.subsectionContainerReducedPadding : {},
          withSidePadding ? styles.subsectionContainer : styles.subSectionContainerNoPadding,
          isDesktop && greyBg ? styles.bgColor : {},
          isDesktop && styles.desktop,
          isCustomPadding && styles.padding20px,
          isWhitelabel && styles.lessGap,
          noPaddingTop && styles.noPaddingTop,
          hideBottomBorder && styles.hideBottomBorder,
          noMarginBottom && styles.noMarginBottom,
          largeMarginBottom && styles.largeMarginBottom,
          className,
        )}
      >
        <div className={styles.largeScreenResponsive}>
          <div
            className={formatClassNames(
              !subtitle && styles.subsectionNoSubtitle,
              withSidePadding ? styles.header : styles.headerWithPadding,
              isDesktop && styles.headerDesktop,
              headerAside && styles.headerWithAside,
            )}
          >
            {headerAside ? (
              <>
                <div className={styles.headerText}>{heading}</div>
                <div className={styles.headerAside}>{headerAside}</div>
              </>
            ) : (
              heading
            )}
          </div>
          <div className={formatClassNames(styles.content)}>{children}</div>
        </div>
        <div
          className={formatClassNames(
            styles.bottomBorder,
            isDesktop && styles.bottomBorderDesktop,
            hideBottomBorder && styles.bottomBorderHidden,
          )}
        />
      </div>
    </>
  );
};

export default wrapperHOC(Subsection, {
  componentName: "Subsection-Home",
  showForChina: true,
});
